import React from 'react';
import BondDocuments from '../../components/shared/BondDocuments';

export default function IssuerBondDocuments() {
    return <BondDocuments role="issuer" />;
}
